module.exports = __webpack_public_path__ + "img/cloud.54bb5f9f.svg";